module.exports = __webpack_public_path__ + "static/media/enchanting-4.09b96b2a.png";